import Link from "./Link.vue";
import { pluginify } from "./../../util";
export default pluginify(Link);
export { Link };
